import React, { Outlet } from 'react-router-dom';

import { Stack } from '@mui/material';

import Layout from './Components/Layout';
import SubNavLink from './Components/SubNavLink';

function JobInformation() {
  return (
    <Layout isAvatarButtonsAvailable={false} message='Job Informations'>
      <Stack
        direction='row'
        gap={2}
        width='fit-content'
        mx={{ xs: 'auto', md: 'initial' }}
      >
        <SubNavLink to='in-complete'>Incomplete Jobs</SubNavLink>
        <SubNavLink to='complete'>Complete Jobs</SubNavLink>
      </Stack>
      <Outlet />
    </Layout>
  );
}

export default JobInformation;
